<template>
  <section class="notification-search">

    <!-- slow initial load indicator -->
    <div v-if="!results && isLoading">Performing search&hellip;</div>
    <!-- eo:slow initial load indicator -->

    <!-- paged results -->
    <NotificationsPager
      v-model="nextPage"
      :results="results"
      :loading="isLoading"
      @input="runSearch">

      <!-- results -->
      <notification-results
        :results="results"
        :highlight="highlight"
        :highlight-prefix="highlightPrefix"
        />
      <!-- eo:results -->

    </NotificationsPager>
    <!-- eo:paged results -->
    
  </section>
</template>

<script>
import { search } from '@/services/api/notifications/search'
import { attemptActionWithToast } from '@/services/prompts'
import NotificationsPager from '../NotificationsPager.vue'
import NotificationResults from '../NotificationResults.vue'

export default {
  components: { NotificationsPager, NotificationResults },
  props: {
    filters: Object,
    highlight: String,
    highlightPrefix: String,
    callback: Function,
  },
  data () {
    return {
      results: null,
      timer: null,
      nextPage: null,
      isLoading: false,
    }
  },
  watch: {
    async filters () {
      this.nextPage = null // reset page as filters have changed
      await this.runSearch()
    }
  },
  async mounted () {
    // update regularly
    this.timer = setInterval(() => {
      if (this.nextPage == null) {
      this.runSearch()
      }
    }, 10*1000)
    // start with a search
    await this.runSearch()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    async runSearch () {
      await attemptActionWithToast(
        this,
        async () => {
          this.results = await search({ 
            ...this.filters,
            nextPage: this.nextPage,
            includeAggregations: true, // always include aggregations
          })
          // need to let the parent know about this?
          if (typeof this.callback === 'function') {
            this.callback(this.results)
          }
        },
        state => this.isLoading = state,
        null,
        e => `unable to search: ${e.message}`
      )
    }
  }
}
</script>
